import Vue from 'vue'
import Router from 'vue-router'
//import Utilities from './utilities'

/*const Homepage = () => import('./components/views/homepage').then(function(Homepage) {
    if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Homepage View loaded')
    return Homepage
})*/

const NewQuote = () => import('./components/views/new-quote').then(function(NewQuote) {
    if(process.env.VUE_APP_MODE != 'production') window.console.log('async: NewQuote View loaded')
    return NewQuote
})

const SingleSoldquote = () => import('./components/views/single-soldquote').then(function(SingleSoldquote) {
    if(process.env.VUE_APP_MODE != 'production') window.console.log('async: SingleSoldquote View loaded')
    return SingleSoldquote
})

Vue.use(Router)

let router = new Router({
    mode: process.env.VUE_APP_ROUTER_MODE,
    routes:
    [
        {
            path: '/',
            name: 'homepage',
            //component: Homepage,
            component: () => import('./components/views/requests').then(function(Requests) {
              if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Requests View loaded')
              return Requests
            }),
        },
        {
            path: '/lavorazione-richiesta/:request_id',
            name: 'new-quote',
            props: true,
            component: NewQuote,
        },
        {   //lmbo973 ::: completamento di una proposta venduta
            path: '/completamento-proposta/:soldquotes_id',
            name: 'single-soldquote',
            props: true,
            component: SingleSoldquote,
        },
        {
            path: '/richieste',
            name: 'requests',
            //is_private: false, //custom attribute
            component: () => import('./components/views/requests').then(function(Requests) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Requests View loaded')
                return Requests
            }),
        },
        {
          path: '/prenotazioni',
          name: 'soldquotes',
          //is_private: false, //custom attribute
          component: () => import('./components/views/soldquotes').then(function(Soldquotes) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Soldquotes View loaded')
            return Soldquotes
          }),
        },
        {
          path: '/strutture',
          name: 'structures',
          //is_private: false, //custom attribute
          component: () => import('./components/views/structures').then(function(Structures) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Structures View loaded')
            return Structures
          }),
        },
        {
            path: '/notifications',
            name: 'notifications',
            //publicRoute: false, //custom attribute
            component: () => import('./components/views/notifications').then(function(Notifications) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Notifications View loaded')
                return Notifications
            }),
        },
        {
          path: '/user-request/:request_id',
          name: 'view_user_request',
          //publicRoute: false, //custom attribute
          props: true,
          component: () => import('./components/views/user-request').then(function(UserRequest) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: UserRequest View loaded')
            return UserRequest
          }),
        },

        // gestisce i "404", !!! DEVE STARE PER ULTIMA !!!
        {
          path: '*',
          name: 'not-found',
          component: () => import('./components/views/not-found').then(function(NotFound) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: NotFound View loaded')
            return NotFound
          }),
          /*props: {
            prerenderStatusCode: '404',
          }*/
        },
    ]
})

/*
router.beforeEach((to, from, next) => {
    (to, from, next)
    next()
    return
})

router.afterEach((to) => {
    (to)
    return
})
*/

export default router